import { render, staticRenderFns } from "./ObjectCreator.vue?vue&type=template&id=da64d16c&scoped=true&"
import script from "./ObjectCreator.vue?vue&type=script&lang=js&"
export * from "./ObjectCreator.vue?vue&type=script&lang=js&"
import style0 from "./ObjectCreator.vue?vue&type=style&index=0&id=da64d16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da64d16c",
  null
  
)

export default component.exports